import React from 'react';
import Images from '../assets/AllImages';

const mainData = [
    {
        heading: "Competitions & Events",
        items: [
            {
                img: Images.NEWS1,
                title: "Prishtina Open 2025: The Region's Premier Swim Meet",
                desc: 'Step Arena will host over 500 swimmers from 10 countries during the highly anticipated "Prishtina Open", set for July 12–14.',
            },
            {
                img: Images.NEWS2,
                title: "Night Swim Challenge: Speed Under the Stars",
                desc: "Experience the thrill of competition after dark. Our inaugural Night Swim Challenge will take place in the outdoor Olympic pool with full lighting and music.",
            },
            {
                img: Images.NEWS3,
                title: "Youth Relay Day: A Celebration of Team Spirit",
                desc: "Local clubs and schools come together for a day of fun and teamwork in the pool. This event is focused on encouraging young swimmers and building a community of support.",
            },
        ],
    },
    {
        heading: "Training & Performance",
        items: [
            {
                img: Images.NEWS4,
                title: "Elite Swim Camp Kicks Off Summer Sessions",
                desc: "Our Elite Swim Camp welcomes athletes from across the region for two weeks of intensive technique training, video analysis, and personalized coaching.",
            },
            {
                img: Images.NEWS5,
                title: "Dryland Training Studio Now Open",
                desc: "Step Arena introduces a brand-new space for dryland performance sessions. From strength to flexibility, this area supports athlete development beyond the pool.",
            },
            {
                img: Images.NEWS6,
                title: "One-on-One Performance Coaching Now Available",
                desc: "Athletes can now book private sessions with our certified coaches for customized progress plans, tailored to their goals and competition calendars.",
            },
        ],
    },
    {
        heading: "Wellness & Recovery",
        items: [
            {
                img: Images.NEWS7,
                title: "Step Spa Introduces Deep Muscle Recovery Therapy",
                desc: "Our latest spa service is designed for post-competition muscle relief. This therapy combines hydrotherapy with focused massage techniques for optimal recovery.",
            },
            {
                img: Images.NEWS8,
                title: "Guided Aquafitness for Stress Relief Now Every Friday",
                desc: "Our weekly Aquafitness class now includes guided breathing and mobility techniques. It’s a perfect way to unwind while staying active in the water.",
            },
            {
                img: Images.NEWS9,
                title: "Wellness Week: Free Consultations & Mini Treatments",
                desc: "During Wellness Week, visitors can enjoy free mini-massages, nutrition tips, and spa tours. Join us in prioritizing your physical and mental well-being.",
            },
        ],
    },
    {
        heading: "Hospitality & Offers",
        items: [
            {
                img: Images.NEWS10,
                title: "Summer Sports Stay Package Now Available",
                desc: "Combine training, accommodation, and tailored meals in one package. Ideal for individual athletes and international teams preparing for competition.",
            },
            {
                img: Images.NEWS11,
                title: "Family Weekend Getaway: Stay, Swim & Dine",
                desc: "Families can enjoy a relaxing weekend at Step Arena with access to all amenities, including children’s pools, spa services, and the health-focused restaurant menu.",
            },
            {
                img: Images.NEWS12,
                title: "Our hotel and meeting facilities are ideal for business retreats with a healthy twist. Enjoy productive sessions, spa relaxation, and gourmet dining in one location.",
                desc: "",
            },
        ],
    },
];


const NEWSCARD = ({ img, title, desc, date }) => {
    return (
        <div className="col-12 col-md-4 col-sm-6">
            <div className="border rounded p-2 h-100 text-md-center">
                <img src={img} alt={title}  className="w-100 mb-4" style={{ height: "180px", objectFit: "cover" }} />
                <h5 className='text-primary fw-bold'>{title}</h5>
                <p>{desc}</p>
                <span className="text-muted">{date || "17.06.2025"}</span>
            </div>
        </div>
    );
};


const NEWS = () => {
    return (
        <>
            <main>
                <div className="container-fluid bg-primary py-3 py-md-0">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 px-5">
                            <h5 className='text-white fw-bold my-0'>NEWS</h5>
                        </div>
                        <div className="col-12 col-md-6 px-5 d-none d-sm-block">
                            <img src={Images.Vactor2} alt="" className='w-50 float-end' />
                        </div>
                    </div>
                </div>
            </main>

            <div className="container my-4">
                {mainData.map((group, idx) => (
                    <div key={idx} className="mb-5">
                        <h2 className="text-primary fw-bold mb-4">{group.heading}</h2>
                        <div className="row g-3">
                            {group.items.map((item, i) => (
                                <NEWSCARD key={i} {...item} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default NEWS;
